import { makeStyles, Backdrop, CircularProgress } from '@material-ui/core';
import React from 'react';

export type LoadingBackdropProps = {
    isLoading: boolean
}

export function LoadingBackdrop ({ isLoading }: LoadingBackdropProps) {
    const cls = useStyles();

    return (
        <Backdrop className={cls.root} open={isLoading}>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        position: "absolute",
        zIndex: 999999999
    }
}));